import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { useRouter } from 'next/router';

import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const { locale } = useRouter();

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1750648841457/ocean_kv.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1750150990698/ocean_kv_h5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1750211298590/ocean_kv_h5_2.jpg',
        // label: labelText,
        // title: t('title'),
        // desc: t('desc'),

        // lType: 'filled',
        // lChildren: t('btn1'),
        // lHref: '#subscription-products-section',
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
